import { addClass, removeClass } from '../helpers/class_helper';
import Tabs from './tabs'


export default class Stepper extends Tabs {

/*-- Private methods ---------------------------------------------------------*/

  _activateTab(step) {
    addClass(step, this._options.tabActiveClass);
    removeClass(step, 'disabled');
  }

}



// WEBPACK FOOTER //
// ./assets/javascripts/libs/stepper.js